// Product categories aligned with the extracted Sinopec Singapore catalog.
export const PRODUCT_CATEGORIES: Record<string, string> = {
  AUTOMOTIVE_LUBRICANTS: 'Automotive Lubricants',
  INDUSTRIAL_LUBRICANTS: 'Industrial Lubricants',
  MARINE_LUBRICANTS: 'Marine Lubricants',
  GREASES: 'Greases',
  SPECIALTY_FLUIDS: 'Specialty Fluids'
};

export const AUTOMOTIVE_SUBCATEGORIES = {
  ENGINE_OIL: 'Engine Oil',
  MOTORCYCLE_OIL: 'Motorcycle Oil',
  AUTOMOTIVE_GEAR_OIL: 'Automotive Gear Oil',
  RAILROAD_ENGINE_OIL: 'Railroad Engine Oil',
  TRACTOR_OIL: 'Tractor Oil',
  TRANSMISSION_FLUID: 'Transmission Fluid'
};

export const INDUSTRIAL_SUBCATEGORIES = {
  BEARING_OIL: 'Bearing Oil',
  COMPRESSOR_OIL: 'Compressor Oil',
  CYLINDER_OIL: 'Cylinder Oil',
  GAS_ENGINE_OIL: 'Gas Engine Oil',
  GENERAL_INDUSTRIAL_OIL: 'General Industrial Oil',
  HEAT_TRANSFER_OIL: 'Heat Transfer Oil',
  HYDRAULIC_OIL: 'Hydraulic Oil',
  INDUSTRIAL_GEAR_OIL: 'Industrial Gear Oil',
  METALWORKING_FLUID: 'Metalworking Fluid',
  ROCK_DRILL_AIR_TOOL_OIL: 'Rock Drill / Air Tool Oil',
  RUST_PREVENTIVE_OIL: 'Rust Preventive Oil',
  SLIDEWAY_OIL: 'Slideway Oil',
  SPECIALTY_INDUSTRIAL_OIL: 'Specialty Industrial Oil',
  SYNTHETIC_INDUSTRIAL_OIL: 'Synthetic Industrial Oil',
  TURBINE_OIL: 'Turbine Oil'
};

export const MARINE_SUBCATEGORIES = {
  CYLINDER_OIL: 'Cylinder Oil',
  MARINE_OIL: 'Marine Oil',
  SYSTEM_OIL: 'System Oil',
  TRUNK_PISTON_ENGINE_OIL: 'Trunk Piston Engine Oil'
};

export const GREASE_SUBCATEGORIES = {
  AUTOMOTIVE_GREASE: 'Automotive Grease',
  BEARING_GREASE: 'Bearing Grease',
  MULTIPURPOSE_GREASE: 'Multipurpose Grease',
  SYNTHETIC_GREASE: 'Synthetic Grease'
};

export const SPECIALTY_FLUID_SUBCATEGORIES = {
  BRAKE_FLUID: 'Brake Fluid',
  DIESEL_EXHAUST_FLUID: 'Diesel Exhaust Fluid',
  DETERGENT: 'Detergent',
  HYDRAULIC_FLUID: 'Hydraulic Fluid'
};

export const ENGINE_OIL_TYPES = [
  'Diesel Engine Oil',
  'Gas Engine Oil',
  'Gasoline Engine Oil'
];

export const MOTORCYCLE_OIL_TYPES = [
  '4T Motorcycle Oil',
  'Scooter Oil'
];

export const AUTOMOTIVE_GEAR_OIL_TYPES = [
  'Automotive Gear Oil',
  'Heavy Duty Vehicle Gear Oil',
  'Limited Slip Gear Oil'
];

export const RAILROAD_ENGINE_OIL_TYPES = [
  'Railroad Engine Oil'
];

export const TRACTOR_OIL_TYPES = [
  'Tractor Oil'
];

export const TRANSMISSION_FLUID_TYPES = [
  'Automatic Transmission Fluid',
  'Final Drive & Axle Oil',
  'Heavy Duty Transmission Fluid',
  'Hydraulic Transmission Fluid',
  'Manual Transmission / Gear Oil',
  'Manual Transmission Fluid'
];

export const HYDRAULIC_OIL_TYPES = [
  'Anti-wear Hydraulic Oil',
  'High Pressure Ashless Hydraulic Oil',
  'Low Temperature Hydraulic Oil',
  'Outdoor Hydraulic Oil',
  'Ultra Low Temperature Hydraulic Oil'
];

export const INDUSTRIAL_GEAR_OIL_TYPES = [
  'Heavy Duty Industrial Gear Oil',
  'Industrial Gear Oil',
  'Medium Duty Industrial Gear Oil',
  'Open Gear Oil',
  'Worm Gear Oil'
];

export const COMPRESSOR_OIL_TYPES = [
  'Air Compressor Oil',
  'Oil Injection Rotary Compressor Oil',
  'Refrigeration Compressor Oil',
  'Synthetic Compressor Oil'
];

export const CYLINDER_OIL_TYPES = [
  'Steam Cylinder / Trolley Bearing Oil'
];

export const GAS_ENGINE_OIL_TYPES = [
  'Stationary Gas Engine Oil'
];

export const GENERAL_INDUSTRIAL_OIL_TYPES = [
  'Total Loss System Oil'
];

export const HEAT_TRANSFER_OIL_TYPES = [
  'Heat Transfer Oil',
  'Synthetic Heat Transfer Oil'
];

export const METALWORKING_FLUID_TYPES = [
  'Aluminum Cold Rolling Oil',
  'Cutting Fluid',
  'Cutting Oil',
  'Drawing Oil',
  'EDM Oil',
  'Isothermal Quenching Oil',
  'Punching Oil',
  'Quenching Oil',
  'Rust Preventive Oil'
];

export const ROCK_DRILL_AIR_TOOL_OIL_TYPES = [
  'Rock Drill Oil'
];

export const RUST_PREVENTIVE_OIL_TYPES = [
  'Wire Rope Antirust Oil'
];

export const SLIDEWAY_OIL_TYPES = [
  'Slideway Hydraulic Oil',
  'Slideway Oil'
];

export const SPECIALTY_INDUSTRIAL_OIL_TYPES = [
  'Sealing Oil'
];

export const SYNTHETIC_INDUSTRIAL_OIL_TYPES = [
  'High-temperature Roller Bar Oil',
  'High-temperature Steel Belt Oil',
  'Synthetic Industrial Gear Oil'
];

export const TURBINE_OIL_TYPES = [
  'Anti-Ammonia Turbine Oil',
  'Classic Turbine Oil',
  'Extreme Pressure Turbine Oil',
  'Gas Turbine Oil',
  'Long Service Life Turbine Oil',
  'Turbine Oil'
];

export const BEARING_OIL_TYPES = [
  'Bearing Oil'
];

export const MARINE_OIL_TYPES = [
  'Dual Fuel Marine Engine Oil',
  'Marine Diesel Engine Oil'
];

export const MARINE_SYSTEM_OIL_TYPES = [
  'Marine System Oil'
];

export const MARINE_CYLINDER_OIL_TYPES = [
  'Marine Cylinder Oil'
];

export const MARINE_TRUNK_PISTON_ENGINE_OIL_TYPES = [
  'Marine Trunk Piston Engine Oil'
];

export const SYNTHETIC_GREASE_TYPES = [
  'Aviation Grease',
  'Cable Protection Grease',
  'EP High-Temperature Grease',
  'High-temperature Anti-seize Lubricant',
  'Lithium Complex Moly Grease'
];

export const MULTIPURPOSE_GREASE_TYPES = [
  'Crystal Grease',
  'Food Grade Grease',
  'Lithium Grease',
  'MP Grease',
  'Multipurpose EP Grease',
  'Multipurpose Grease'
];

export const AUTOMOTIVE_GREASE_TYPES = [
  'High-Temperature Automotive Grease',
  'Lithium Grease',
  'Vehicle Chassis Grease'
];

export const BEARING_GREASE_TYPES = [
  'Extreme Pressure Lithium Grease',
  'High Temperature Grease',
  'Lithium Complex Grease',
  'Mining Grease',
  'Moly Grease',
  'Open Gear Grease',
  'Polyurea Grease',
  'Roller Bearing Grease',
  'Sugar Mill Grease'
];

export const BRAKE_FLUID_TYPES = [
  'Synthetic Brake Fluid'
];

export const DIESEL_EXHAUST_FLUID_TYPES = [
  'Diesel Exhaust Fluid'
];

export const DETERGENT_TYPES = [
  'Truckwash Detergent'
];

export const HYDRAULIC_FLUID_TYPES = [
  'Fire-resistant Hydraulic Fluid'
];

export interface ProductCategoryNode {
  subcategories: Record<string, string[]>;
}

export const PRODUCT_CATEGORY_STRUCTURE: Record<string, ProductCategoryNode> = {
  [PRODUCT_CATEGORIES.AUTOMOTIVE_LUBRICANTS]: {
    subcategories: {
      [AUTOMOTIVE_SUBCATEGORIES.ENGINE_OIL]: ENGINE_OIL_TYPES,
      [AUTOMOTIVE_SUBCATEGORIES.MOTORCYCLE_OIL]: MOTORCYCLE_OIL_TYPES,
      [AUTOMOTIVE_SUBCATEGORIES.AUTOMOTIVE_GEAR_OIL]: AUTOMOTIVE_GEAR_OIL_TYPES,
      [AUTOMOTIVE_SUBCATEGORIES.RAILROAD_ENGINE_OIL]: RAILROAD_ENGINE_OIL_TYPES,
      [AUTOMOTIVE_SUBCATEGORIES.TRACTOR_OIL]: TRACTOR_OIL_TYPES,
      [AUTOMOTIVE_SUBCATEGORIES.TRANSMISSION_FLUID]: TRANSMISSION_FLUID_TYPES
    }
  },
  [PRODUCT_CATEGORIES.INDUSTRIAL_LUBRICANTS]: {
    subcategories: {
      [INDUSTRIAL_SUBCATEGORIES.BEARING_OIL]: BEARING_OIL_TYPES,
      [INDUSTRIAL_SUBCATEGORIES.COMPRESSOR_OIL]: COMPRESSOR_OIL_TYPES,
      [INDUSTRIAL_SUBCATEGORIES.CYLINDER_OIL]: CYLINDER_OIL_TYPES,
      [INDUSTRIAL_SUBCATEGORIES.GAS_ENGINE_OIL]: GAS_ENGINE_OIL_TYPES,
      [INDUSTRIAL_SUBCATEGORIES.GENERAL_INDUSTRIAL_OIL]: GENERAL_INDUSTRIAL_OIL_TYPES,
      [INDUSTRIAL_SUBCATEGORIES.HEAT_TRANSFER_OIL]: HEAT_TRANSFER_OIL_TYPES,
      [INDUSTRIAL_SUBCATEGORIES.HYDRAULIC_OIL]: HYDRAULIC_OIL_TYPES,
      [INDUSTRIAL_SUBCATEGORIES.INDUSTRIAL_GEAR_OIL]: INDUSTRIAL_GEAR_OIL_TYPES,
      [INDUSTRIAL_SUBCATEGORIES.METALWORKING_FLUID]: METALWORKING_FLUID_TYPES,
      [INDUSTRIAL_SUBCATEGORIES.ROCK_DRILL_AIR_TOOL_OIL]: ROCK_DRILL_AIR_TOOL_OIL_TYPES,
      [INDUSTRIAL_SUBCATEGORIES.RUST_PREVENTIVE_OIL]: RUST_PREVENTIVE_OIL_TYPES,
      [INDUSTRIAL_SUBCATEGORIES.SLIDEWAY_OIL]: SLIDEWAY_OIL_TYPES,
      [INDUSTRIAL_SUBCATEGORIES.SPECIALTY_INDUSTRIAL_OIL]: SPECIALTY_INDUSTRIAL_OIL_TYPES,
      [INDUSTRIAL_SUBCATEGORIES.SYNTHETIC_INDUSTRIAL_OIL]: SYNTHETIC_INDUSTRIAL_OIL_TYPES,
      [INDUSTRIAL_SUBCATEGORIES.TURBINE_OIL]: TURBINE_OIL_TYPES
    }
  },
  [PRODUCT_CATEGORIES.MARINE_LUBRICANTS]: {
    subcategories: {
      [MARINE_SUBCATEGORIES.CYLINDER_OIL]: MARINE_CYLINDER_OIL_TYPES,
      [MARINE_SUBCATEGORIES.MARINE_OIL]: MARINE_OIL_TYPES,
      [MARINE_SUBCATEGORIES.SYSTEM_OIL]: MARINE_SYSTEM_OIL_TYPES,
      [MARINE_SUBCATEGORIES.TRUNK_PISTON_ENGINE_OIL]: MARINE_TRUNK_PISTON_ENGINE_OIL_TYPES
    }
  },
  [PRODUCT_CATEGORIES.GREASES]: {
    subcategories: {
      [GREASE_SUBCATEGORIES.AUTOMOTIVE_GREASE]: AUTOMOTIVE_GREASE_TYPES,
      [GREASE_SUBCATEGORIES.BEARING_GREASE]: BEARING_GREASE_TYPES,
      [GREASE_SUBCATEGORIES.MULTIPURPOSE_GREASE]: MULTIPURPOSE_GREASE_TYPES,
      [GREASE_SUBCATEGORIES.SYNTHETIC_GREASE]: SYNTHETIC_GREASE_TYPES
    }
  },
  [PRODUCT_CATEGORIES.SPECIALTY_FLUIDS]: {
    subcategories: {
      [SPECIALTY_FLUID_SUBCATEGORIES.BRAKE_FLUID]: BRAKE_FLUID_TYPES,
      [SPECIALTY_FLUID_SUBCATEGORIES.DIESEL_EXHAUST_FLUID]: DIESEL_EXHAUST_FLUID_TYPES,
      [SPECIALTY_FLUID_SUBCATEGORIES.DETERGENT]: DETERGENT_TYPES,
      [SPECIALTY_FLUID_SUBCATEGORIES.HYDRAULIC_FLUID]: HYDRAULIC_FLUID_TYPES
    }
  }
};
